import React, { useEffect, useRef } from "react";
import { Animated, Platform, ViewStyle } from "react-native";

type StickyPriceWrapperProps = {
  show: boolean;
  children: React.ReactNode;
  topMargin: number;
};

const StickyPriceWrapper = React.forwardRef<any, StickyPriceWrapperProps>(
  ({ show, children, topMargin }, ref) => {
    const opacity = useRef(new Animated.Value(0)).current;
    const translateY = useRef(new Animated.Value(-20)).current;

    useEffect(() => {
      Animated.parallel([
        Animated.timing(opacity, {
          toValue: show ? 1 : 0,
          duration: 200,
          useNativeDriver: Platform.OS !== "web",
        }),
        Animated.timing(translateY, {
          toValue: show ? 0 : -20,
          duration: 200,
          useNativeDriver: Platform.OS !== "web",
        }),
      ]).start();
    }, [show]);

    const animatedStyle: Animated.WithAnimatedObject<ViewStyle> = {
      position: "absolute",
      top: topMargin,
      left: 0,
      right: 0,
      zIndex: show ? 100 : -20,
      opacity: show ? opacity : 0,
      width: show ? "100%" : 0,
      backgroundColor: "white",
      transform: [{ translateY }],
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
    };

    return (
      <Animated.View ref={ref} style={animatedStyle}>
        {children}
      </Animated.View>
    );
  }
);

StickyPriceWrapper.displayName = "StickyPriceWrapper";

export default StickyPriceWrapper;
